import { PrimaryNavIdentifier } from '@zola-helpers/client/dist/es/constants/navConstants';

import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import experimentFlags, { CORE_POST_AUTH_NAV_V3 } from 'util/experimentFlags';

export const isPostAuthNav3Active = (userContext: UserContext | null): boolean => {
  if (!userContext || typeof window === 'undefined') {
    return false;
  }

  const experimentIsActive = experimentFlags.isUnderTest(CORE_POST_AUTH_NAV_V3, userContext, false);

  return experimentIsActive && !userContext.is_guest;
};

export const getPageName = (
  activeLinkId: '' | PrimaryNavIdentifier | undefined,
  activeSecondaryLink: string
): string => {
  if (!activeLinkId && typeof window !== undefined && window.location.pathname.includes('budget')) {
    return 'Budget';
  }

  if (activeSecondaryLink === 'real-weddings') {
    return 'Inspiration';
  }

  // Special case for the wedding boutique collections, which is a boutique page but we want displayed as registry
  if (
    typeof window !== undefined &&
    window.location.pathname.includes('shop/gift-collections/wedding-shop-collections')
  ) {
    return 'Registry';
  }

  switch (activeLinkId) {
    case PrimaryNavIdentifier.ACCOUNT: {
      return 'Account settings';
    }
    case PrimaryNavIdentifier.ADVICE: {
      return 'Advice';
    }
    case PrimaryNavIdentifier.ALBUMS: {
      return 'Albums';
    }
    case PrimaryNavIdentifier.BUDGET: {
      return 'Budget';
    }
    case PrimaryNavIdentifier.CAREERS: {
      return 'Careers';
    }
    case PrimaryNavIdentifier.CHECKLIST: {
      return 'Checklist';
    }
    case PrimaryNavIdentifier.COMMUNITY: {
      return 'Community';
    }
    case PrimaryNavIdentifier.GUEST_LIST: {
      return 'Guest list and RSVPs';
    }
    case PrimaryNavIdentifier.HELP: {
      return 'Help';
    }
    case PrimaryNavIdentifier.OUR_STORY: {
      return 'Our story';
    }
    case PrimaryNavIdentifier.PAPER: {
      return 'Invites and paper';
    }
    case PrimaryNavIdentifier.PRESS: {
      return 'Press';
    }
    case PrimaryNavIdentifier.REGISTRY: {
      return 'Registry';
    }
    case PrimaryNavIdentifier.SEATING: {
      return 'Seating chart';
    }
    case PrimaryNavIdentifier.VENDORS: {
      return 'Venue and vendors';
    }
    case PrimaryNavIdentifier.WEBSITE: {
      return 'Website';
    }
    case PrimaryNavIdentifier.WEDDING_BOUTIQUE: {
      return 'Boutique';
    }
    case PrimaryNavIdentifier.YOUR_WEDDING: {
      return 'Your wedding';
    }
    default:
      return '';
  }
};
